// frontend/src/components/ESIMPackages/PaginationControl.js
import React from "react";
import { TablePagination } from "@mui/material";
import { useTranslation } from "react-i18next";

const PaginationControl = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const { t } = useTranslation();

  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      onPageChange={onPageChange}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={onRowsPerPageChange}
      rowsPerPageOptions={[5, 10, 25, 50]}
      labelRowsPerPage={t("common.pagination.rowsPerPage")}
      labelDisplayedRows={({ from, to, count }) =>
        t("common.pagination.displayedRows", { from, to, count })
      }
    />
  );
};

export default PaginationControl;
